import axios from 'axios';
import store from '@/store/store';
import { actions as _act } from '@/models/store.actions';

export const documentReceiptConfirmsService = {
  get,
  find,
  getDetails,
  update,
  getQuittanceHash,
  confirm,
  download,
  verify
};

let model = {
  get baseUrl() {
    return store.getters[_act.SETT_GET_APIURLGET];
  },
  controller: 'doc-receipt-confirms'
};

function extract(r) {
  return r.data;
}

function get(documentVersionCode: string) {
  return axios
    .get(`${model.baseUrl}${model.controller}?documentVersionCode=${documentVersionCode}`)
    .then(extract);
}

function find(documentVersionCode: string) {
  return axios
    .get(`${model.baseUrl}${model.controller}/find?documentVersionCode=${documentVersionCode}`)
    .then(extract);
}

function getDetails(documentReceiptConfirmUid: string) {
  return axios
    .get(`${model.baseUrl}${model.controller}/${documentReceiptConfirmUid}`)
    .then(extract);
}

function update(documentVersionCode: string, users: any[]) {
  return axios
    .put(`${model.baseUrl}${model.controller}`, { documentVersionCode, users })
    .then(extract);
}

function getQuittanceHash(documentReceiptConfirmUid: string, keyType: number) {
  return axios
    .get(`${model.baseUrl}${model.controller}/${documentReceiptConfirmUid}/hash?keyType=${keyType}`)
    .then(extract);
}

function confirm(documentReceiptConfirmUid: string, quittanceSignature: string, keyType: number) {
  return axios
    .post(`${model.baseUrl}${model.controller}/confirm`, {
      documentReceiptConfirmUid, quittanceSignature, keyType
    })
    .then(extract);
}

function download(documentReceiptConfirmUid: string) {
  return axios
    .get(
      `${model.baseUrl}${model.controller}/${documentReceiptConfirmUid}/files`,
      { responseType: 'blob' });
}

function verify(documentReceiptConfirmUid: string) {
  return axios
    .get(`${model.baseUrl}${model.controller}/${documentReceiptConfirmUid}/verify`)
    .then(extract);
}
